import { all, fork } from 'redux-saga/effects'

import authSagas from '@/containers/Login/AuthSagas'
import pageConfigurationSagas from '@/store/PageConfiguration/PageConfigurationSagas'
import usersManagementSagas from '@/containers/UsersManagement/UsersManagementSagas'
import servicesStatusSagas from '../containers/ServicesStatus/ServicesStatusSagas'
import carbonOffsetsSagas from '../containers/CarbonOffsetManagement/CarbonOffsetsSagas'
import officesManagementSagas from '../containers/OfficesManagement/OfficesManagementSagas'
import assistanceSagas from '../containers/AssistanceProductsManagement/AssistanceSagas'
import dashboardSagas from '../containers/DashboardPage/DashboardSagas'
import subscriptionFormSagas from '../containers/SubscriptionFormPage/SubscriptionFormSagas'
import monConseillerPersoSagas from '../containers/MonConseillerPersoProductsManagement/MonConseillerPersoSagas'
import subscriptionFormV2Sagas from '../containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import clientCallbacksSagas from '@/containers/ClientCallbacksPage/ClientCallbacksSagas'
import additionalProductsToolsSagas from '../containers/AdditionalSalesManagement/additionalProductsToolsSagas'
import searchContactsSagas from '../containers/ContactSearchPage/searchContactsSagas'
import contactsToolsSagas from '@/containers/DevToolsNew/Contacts/contactsSagas'

export default function* rootSaga() {
  yield all([fork(authSagas)])
  yield all([fork(pageConfigurationSagas)])
  yield all([fork(usersManagementSagas)])
  yield all([fork(servicesStatusSagas)])
  yield all([fork(carbonOffsetsSagas)])
  yield all([fork(officesManagementSagas)])
  yield all([fork(assistanceSagas)])
  yield all([fork(monConseillerPersoSagas)])
  yield all([fork(dashboardSagas)])
  yield all([fork(subscriptionFormSagas)])
  yield all([fork(subscriptionFormV2Sagas)])
  yield all([fork(searchContactsSagas)])
  yield all([fork(clientCallbacksSagas)])
  yield all([fork(additionalProductsToolsSagas)])
  yield all([fork(contactsToolsSagas)])
}
